module.exports = __webpack_public_path__ + "static/media/PxGroteskRegular.c452ec24.ttf";